import { create } from "zustand";

/**
 * Below the `lg` breakpoint (iPad portrait and smaller) the portal sidebar is a
 * slide-in drawer: the header's menu button opens it, picking a page / the
 * backdrop / Escape closes it. On `lg`+ the sidebar sits in the layout and can
 * be collapsed away with its arrow (`collapsed`), then brought back from the
 * header. One store for every portal — only one shell is mounted.
 */
interface SidebarDrawerState {
  open: boolean;
  setOpen: (open: boolean) => void;
  /** lg+ only: the sidebar is hidden. Remembered per browser. */
  collapsed: boolean;
  setCollapsed: (collapsed: boolean) => void;
}

const COLLAPSED_KEY = "msq_sidebar_collapsed";

function readCollapsed(): boolean {
  try {
    return localStorage.getItem(COLLAPSED_KEY) === "1";
  } catch {
    return false;
  }
}

export const useSidebarDrawerStore = create<SidebarDrawerState>((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
  collapsed: readCollapsed(),
  setCollapsed: (collapsed) => {
    try {
      localStorage.setItem(COLLAPSED_KEY, collapsed ? "1" : "0");
    } catch {
      // Storage blocked (private window): it just isn't remembered.
    }
    set({ collapsed });
  },
}));
